<template>
<div class="chapter">
<div class="inner_page">
<p class="chapno">CHAPTER 1</p>
<p class="chapname">Leadership Fundamentals</p>
<div class="image">
<p class="fig"><img alt="" src="Images/pg1.jpg"/></p>
</div>
<p class="center">In his search to be a great leader, the young centurion<br/>sought out the Republic’s veteran warrior. Looking up<br/>from his labor, the sage spoke: “I know not what beats<br/>beneath your tunic, but what I saw in a leader from<br/>foot soldiers to proconsul is thus:</p>
<p class="centert">One who makes drill bloodless combat<br/>and combat bloody drill…<br/>One who disciplines the offense and not the offenders…<br/>One whose heart is with the Legion and whose loyalty<br/>is to the Republic…<br/>One who seeks the companionship of the long march<br/>and not the privilege of position…<br/>One whose commission is assigned from above and<br/>confirmed from below…<br/>One who knows the self and, therefore, is true to all…<br/>One who seeks to serve and not to be served…<br/>This is the one who leads best of all.”</p>
<p class="right">J<span class="small">EFFREY</span> S<span class="small">PARA</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Chapter01.vue?1f31be84